// `Symbol.search` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.search
require('../internals/define-well-known-symbol')('search');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.search.js
// module id = 290
// module chunks = 1